export default __webpack_public_path__ + "static/media/infosys.0e299a45.jpg";